/**
 * pendingId — the field zone's ONE client-temp-id discriminator (Field Cancel
 * spec v3 §1). A leaf module with NO imports, on purpose: fetchFieldRecords,
 * FieldSyncSheet, drainFieldQueue and fieldOutbox all read it, and a helper
 * that dragged fieldOutbox's import graph (drainFieldQueue → preflightToken →
 * MSAL) into every one of them would break tests that mock only fieldDb.
 */

/**
 * True when `id` is a client temp id — a record created offline that has not
 * reached the server (minted 'pending-' + uuid in FieldRecordModal's create).
 * ONE definition of the discriminator (Field Cancel spec v3 §1). Takes any
 * value: callers test record_id, tool_id, or an either-of, and some of those
 * may be null/undefined, so it coerces to string rather than assuming one.
 */
export function isPendingRecord(id) {
  return String(id).startsWith('pending-');
}
